export default {
  namespaced: true,
  grid: {
    widgets: {
      alarms: {
        incoming_alarms: {
          title: "Alarmas en espera"
        },
        alarms_being_attended: {
          title: "Alarmas en atención"
        },
        alarms_in_attention: {
          title: "Alarmas en atención"
        },
        pagination: {
          showing: "Mostrando",
          records: "Registros",
          page: "Pág.",
          of: "de"
        },
        search: {
          placeholder: "Buscar por Id de Alarma, Dirección, Tenant, Instalación, Dirección..."
        },
        menu: {
          confirm: "Confirmar",
          attended: "Atendida",
          cancel: "Cancelar",
          display: "Visualizar",
          send_to_seproban: "Enviar a seproban",
          bau: "BAU",
          incidents: "Incidentes",
          reports: "Reportes"
        },
        table: {
          no_data: "No hay información disponible",
          restored_at: "Restablecimiento",
          rows: {
            1: "Alarma",
            2: "Dispositivo",
            3: "Instalación",
            4: "Estado",
            5: "Fecha"
          },
          popover: {
            alarm_id: "ID",
            alarm_type: "Tipo de alarma",
            facility: "Instalación",
            camera: "Dispositivo",
            date: "Fecha",
            taken_by: "Tomado por",
            not_available: "N/A",
            local_hour: "Hora Local",
            central_hour: "Hora Central"
          }
        }
      },
      units: {
        activate_digital_output: "Activar salida digital",
        disable_digital_output: "Desactivar salida digital",
        title: "Instalaciones",
        messages: {
          no_data: "No hay información disponible"
        },
        pagination: {
          showing: "Mostrando",
          records: "Registros",
          page: "Pág.",
          of: "de"
        },
        search: {
          placeholder: "Buscar por Instalación, Dirección...",
          results: "Resultados",
          placeholderSearchUnits: "Buscar instalación",
          placheholderMatches: "Buscar coincidencias"
        },
        table: {
          rows: {
            1: "Nombre"
          }
        },
        subsystems_tree: {
          info: "Información",
          video: {
            title: "Video",
            live_video: "Video en vivo",
            recorded_video: "Video grabado",
            timeline: "Linea de tiempo",
          },
          voip: {
            make_call: 'Llamar',
          },
          activate_digital_output: "Activar salida digital",
          disable_digital_output: "Desactivar salida digital",
        }
      },
      layouts: {
        title: "Layouts"
      },
      views: {
        title: "Vistas"
      },
      widgets: {
        title: "Widgets"
      },
      charts: {
        title: "Gráficas",
        no_data: "No hay información disponible",
      },
      videowall: {
        title: "Videowall"
      },
      scripts: {
        title: "Comandos"
      }
    },
    modals: {
      alarms_status: {
        title_confirm: "¿Está seguro de enviar la alarma?",
        title_attended: "¿Está seguro de dar por atendida la alarma?",
        title_cancel: "¿Está seguro de cancelar la alarma?",
        protocol: 'Protocolo',
        comments: "Comentarios",
        alarm_level: "Nivel de alarma",
        btns: {
          send: "Enviar",
          cancel: "Cancelar"
        },
        fromSameFacility: "De la misma instalación",
        fromSameAlarmType: "Del mismo tipo de alarma",
        fromSameSector: "Del mismo sector"
      },
      update_layout: {
        cameras: "Cámaras",
        pre_alarm: "Pre-Alarma",
        info: "Información",
        alarm_info: "Información de la alarma",
        unit_info: "Información de la instalación",
        plane: "Plano",
        unit_plane: "Mostrar plano de la instalación",
        map: "Mapa",
        alarm_location: "Ubicación de la alarma",
        unit_location: "Ubicación de la instalación",
        gps: "GPS",
        locations: "Localizaciones",
        select_slot: "Selecciona un espacio",
        btns: {
          ok: "Ok"
        }
      }
    },
    tabs: {
      new_tab: "Nueva pestaña",
      context_menu: {
        save_as_view: "Guardar como vista",
        update_view: "Actualizar vista",
        update_name: "Cambiar nombre"
      },
      alert: {
        title: "Alerta de pestañas",
        text: "El límite de pestañas permitidas es {max}."
      }
    },
    timeline: {
      waiting_for_main_camera: 'Esperando cámara principal',
      no_footage_available: 'No footage available for the selected time',
      toolbar: {
        alarms: 'Alarmas',
        objects: 'Objetos',
        filter_type: 'Clic para buscar por objetos',
        zoom_in: 'Acercar',
        zoom_out: 'Alejar',
        x_seconds_fw: '5 segundos adelante',
        x_seconds_bw: '5 segundos atrás',
        play: 'Reproducir',
        pause: 'Pausar',
        synchronize: 'Sincronizar',
        desynchronize: 'Desincronizar',
        download: 'Descargar',
        mostRecentEvent: 'Evento más reciente',
        speed: 'Velocidad',
        facialRecognitionEnrollment: 'Enrolamiento de Reconocimiento Facial',
      },
      objectsModal: {
        title: 'Búsqueda por objetos',
        field1: {
          label: 'Proveedor'
        },
        field2: {
          label: 'Tipo'
        },
        field3: {
          label: 'Desde'
        },
        field4: {
          label: 'Hasta'
        },
        field5: {
          label: 'Objeto'
        },
        operators: {
          equal_to: 'igual a',
          not_equal_to: 'diferente de',
          contains: 'contiene',
          not_contains: 'no contiene',
          gt: 'mayor que',
          lt: 'menor que',
          gte: 'mayor o igual que',
          lte: 'menor o igual que',
          is_in: 'está en',
          is_not_in: 'no está en',
        }
      },
      downloadModal: {
        title: 'Descarga de vídeos',
      },
    },
    frame: {
      url: 'url'
    },
    slots: {
      main: {
        messages: {
          widget_not_be_added: 'No fue posible agregar el widget',
          timeline_widget_exists: 'Ya existe un widget del tipo Timeline',
          chat_widget_exists: 'Ya se cargo este chat',
          detection_event_widget_exists: 'Ya existe un widget del tipo Detección de eventos',
          empty_text: 'Arrastre y suelte cámaras, mapas y widgets aquí'
        }
      },
      info: {
        unit: 'Instalación',
        address: 'Dirección',
        actions: 'Acciones',
        btns: {
          confirmed: 'Confirmar',
          attended: 'Atendida',
          cancel: 'Cancelar',
          reopen: 'Reabrir alarma',
        },
        description: 'Descripción',
        company: 'Empresa',
        latitude: 'Latitud',
        longitude: 'Longitud',
        exterior_number: 'Número exterior',
        suburb: 'Colonia',
        municipality: 'Municipo',
        postal_code: 'C.P.',
        country: 'País',
        region: 'Estado',
        tracing: 'Seguimiento',
        protocol: 'Protocolo',
        attending_comments: 'Motivo de atención',
        solved_comments: 'Motivo de solución',
        cancel_comments: 'Motivo de cancelación',
        status: 'Estatus',
        folio_cad: 'Folio CAD',
        data: 'Información adicional',
        camera: {
          review_start: 'Inicio de revisión',
          review_end: 'Fin de revisión',
          events_review: 'Revisión de eventos',
          center: 'Centro',
          sector: 'Sector',
          previous_time: 'Tiempo previo',
          later_time: 'Tiempo posterior',
          reseller: {
            name: 'Nombre',
            company: 'Empresa'
          },
          bridge: {
            account_id: 'Account Id',
            bridge_id: 'Bridge Id',
            device_name: 'Nombre de dispositivo'
          },
          bridge_account: {
            account_id: 'Account Id',
            name: 'Nombre'
          },
        },
        sip_call: {
          state: 'Estado',
          from: 'Desde',
          to: 'Hacia',
          make_call: 'Llamar',
          origin_date: 'Fecha de Origen',
          audio_record: 'Grabación'
        },
        fr: {
          title: 'Reconocimiento Facial',
          enrolled_person: 'Persona enrolada',
          face_detected: 'Rostro detectado',
          detection: 'Detección',
          camera_name: 'Nombre de la cámara',
          person_name: 'Nombre de la persona',
          list_name: 'Nombre de la lista',
          age: 'Edad',
          gender: 'Género',
          emotion: 'Emoción captada',
          glasses: 'Uso de lentes',
          picture_quality: 'Calidad de imagen',
          blurriness: 'Borrosidad',
          darkness: 'Oscuridad',
          brightness: 'Brillo',
          saturation: 'Saturación',
          score: 'Puntaje de retrato',
          similarity: 'Puntaje de similitud',
          match_history: 'Historial De Coincidencias',
          waiting_detection: "Esperando detección",
          welcome: "Bienvenido",
          genderFemale: 'Femenino',
          genderMale: 'Masculino',
        },
        detection_events: {
          default: {
            title: 'Evento de detección'
          },
          lpr: {
            title: 'Reconocimiento de placas',
          },
          loitering: {
            title: 'Merodeo',
          },
          crowded: {
            title: 'Aglomeración'
          },
          fr: {
            title: 'Reconocimiento facial',
          },
          people_counting: {
            title: 'Conteo de personas',
          },
          people_entering: {
            title: 'Personas entrando',
          },
          people_exiting: {
            title: 'Personas saliendo',
          },
          prohibited_parking: {
            title: 'Estacionamiento prohibido',
          },
          vehicle_count: {
            title: 'Conteo de vehículos',
          },
          wrong_way: {
            title: 'Sentido contrario',
          },
          delimited_zone: {
            title: 'Seguridad perimetral',
          },
          person_fallen: {
            title: 'Persona acostada',
          },
          smart_motion_detection: {
            title: 'Smart Motion Detection',
          },
          object_count: {
            title: 'Conteo de objetos',
          },
          person_in_area: {
            title: 'Persona en área'
          },
          intrusion: {
            title: 'Intrusión'
          },
          tripwire: {
            title: 'Cable Trampa'
          },
          labels: {
            overall_picture: 'Imagen general',
            plate: 'Placa',
            camera_name: 'Nombre de la cámara',
            city: 'Ciudad',
            date: 'Fecha de captura',
            speed: 'Velocidad',
            brand: 'Marca',
            model: 'Modelo',
            color: 'Color',
            class: 'Clase',
            list: 'Lista',
            confidence: 'Fiabilidad',
          },
        },
        sip: {
          title: 'SIP Call',
          session_id: 'SessionId',
          state: 'Estado',
          from: 'Desde',
          to: 'a',
        },
        workflow_logs: {
          title: 'Registro de flujos de trabajo',
          no_workflow_data: 'No hay datos de workflow disponibles'
        },
        analytic_record: {
          title: 'Registro Analítico',
          alarm_category: 'Categoría de alarma',
          camera_name: 'Nombre de la cámara',
          matched_rules: 'Reglas coincidentes',
          priority: 'Prioridad',
        },
        sensors: {
          title: 'Sensores',
          name: 'Nombre',
          type: 'Tipo',
          last_measurement: 'Última medición',
          measurement: 'Medición de Alarma',
          high_critical: 'Medición Alta Critica',
          high_warning: 'Advertencia de Medición Alta',
          low_critical: 'Medición Baja Critica',
          low_warning: 'Advertencia de Medición Baja',
        },
        emergency_contacts: "Contactos de Emergencia",
        no_emergency_contacts: "Esta unidad no tiene contactos de emergencia",
        contact_info: {
          name: "Nombre",
          phone: "Teléfono",
          description: "Descripción"
        },
        general_summary: "Resumen General",
        facility_detail: "Detalles de la Instalación",
        risk_evaluation: "Evaluación de Riesgo",
        cad_data: "C5 - CAD",
        institutions: "Instituciones",
        alarm_groups: "Grupos de Alarma",
        smart_detection: "Smart Detection",
        lpr: "LPR",
        analytic_record_title: "Analytic Record",
        sip_calls: "SIP Calls",
        pbx_calls: "PBX Calls",
        mobotix: "Mobotix / ME",
        alarm_bridge_data: "Alarm Bridge Data",
        default_detection: "Detecciones",
        action_plan_log: "Action Plan Log",
        incident_log: "Incident Log",
        comments: "Comentarios",
        unit_title: "Unidad",
        camera_title: "Cámara",
        swift_sensor: "Swift Sensor",
        swift_sensor_tree: "Swift Sensor (Tree)",
        actuator: "Actuador",
        generic_device: "Dispositivo Genérico",
        alarm_id: "ID de Alarma",
        creation_date: "Fecha de Creación",
        risk_percentage: "Porcentaje de riesgo",
        cad_folio: "Folio CAD",
        answer_call: "Contestar",
        copy_id: "Copiar ID",
        copied: "¡Copiado!",
        pdf_export: "Exportar PDF",
        no_comments_yet: "No hay comentarios aún",
        write_comment_here: "Escribe un comentario aquí"
      },
      interphone: {
        type: 'Tipo',
        alarm: 'Alarma',
        created: 'Creado',
        updated: 'Actualizado',
        user: 'Usuario',
      }
    },
    widgets_section: {
      weather: {
        title: 'Clima',
        errorGeloocation: 'No se pudo obtener la ubicación',
        permissionDenied: 'No se permitio acceder a la ubicación,  habilíte los permisos en su dispositivo.'
      },
      face_detection: {
        title: 'Busqueda de Rostros',
      },
      map: {
        title: 'Mapa',
      },
      chart: {
        title: 'Gráfica',
      },
      detection_event: {
        title: 'Detección de evento',
      },
      neo_dash: {
        title: 'Neo4j Reportes',
        predefined_question: 'Preguntas predefinidas',
        cameras: 'Cámaras',
        cameras_placeholder: 'Selecciona una o varias cámaras',
        colors: 'Colores',
        colors_placeholder: 'Selecciona uno o varios colores',
        time_range: 'Rango de tiempo',
        last_days: 'Últimos {n} días',
        all_time: 'Todo el historial',
        plate_route_placeholder: 'Placa (ej. ABC123)',
        min_speed_label: 'Velocidad mínima (km/h)',
        min_speed_placeholder: '50',
        window_seconds_label: 'Ventana de tiempo (segundos)',
        window_seconds_placeholder: '10',
        questions: {
          cars_by_day: '¿Cuántos carros han pasado por día?',
          cars_by_color: '¿Cuántos carros por color? (un grafo por color)',
          cars_by_hour: '¿En qué horas pasan más/menos carros?',
          cars_by_camera: '¿Cuántos carros ha detectado cada cámara?',
          vehicle_types: '¿Qué tipos de vehículos han pasado?',
          vehicle_brands: '¿Qué marcas han pasado?',
          top_plates: 'Top 10 placas más detectadas',
          plates_registered: '¿Cuántas placas hay registradas?',
          camera_flow: '¿Cuáles son las rutas más comunes entre cámaras?',
          plate_clones: '¿Qué placas parecen clonadas o mal leídas? (vinculadas a más de un vehículo)',
          plate_route: '¿Por dónde se movió esta placa?',
          over_speed: '¿Qué placas exceden el límite de velocidad?',
          exposure_time: '¿En qué ubicaciones el tráfico tiene más tiempo de exposición?',
          repeat_rate: '¿Qué % de la audiencia es nueva vs. recurrente?',
          new_vs_repeat_hour: '¿En qué horarios predomina audiencia nueva vs. conocida?',
          convoy: '¿Qué placas se detectan juntas, en pocos segundos, en más de una cámara?',
        },
        report: {
          detections: 'Detecciones',
          plate: 'Placa',
          vehicle: 'Vehículo',
          vehicles: 'Vehículos asociados',
          empty: 'Sin datos en el rango seleccionado',
          error: 'No se pudo cargar el reporte',
          no_plate_image: 'Sin imagen',
          no_detections: 'No hay detalles de detección para esta placa',
          brand: 'Marca',
          type: 'Tipo',
          vehicle_color: 'Color del vehículo',
          plate_color: 'Color de placa',
          speed: 'Velocidad',
          direction: 'Dirección',
          camera: 'Cámara',
          date: 'Fecha',
          top_routes: 'Rutas principales por esta cámara',
          clone_alert: 'Posible clonación: esta placa está vinculada a más de un vehículo distinto',
          convoy_alert: 'Se detecta junto a otra(s) placa(s) en más de una cámara: posible convoy',
          convoy_partners: 'Viaja junto con',
          convoy_partner_detail: '{plate} ({count}x en {cameras} cámaras)',
          speeding_alert: 'Exceso de velocidad: hasta {speed} km/h detectados',
          avg_speed: 'Velocidad promedio',
          exposure_index: 'Índice de exposición',
          total_plates: 'Placas totales',
          new_plates: 'Placas nuevas',
          repeat_plates: 'Placas recurrentes',
          repeat_rate: 'Tasa de recurrencia',
          business_hint: {
            cars_by_camera: 'Compara el tráfico entre ubicaciones para justificar tarifas de valla diferenciadas por sitio.',
            cars_by_day: 'Elige 90 días o Todo el historial para ver la tendencia de crecimiento del tráfico y argumentar renovaciones.',
            cars_by_hour: 'Identifica las horas de mayor tráfico para decidir cuándo rotar los anuncios en pantallas digitales.',
            vehicle_brands: 'El mix de marcas indica el poder adquisitivo de la audiencia: útil para vender espacio a marcas premium o masivas.',
            vehicle_types: 'Si predominan vehículos comerciales, esa ubicación es más atractiva para marcas B2B o de logística.',
            exposure_time: 'El índice de exposición combina volumen y velocidad promedio: entre más alto, más tiempo ve el anuncio esa audiencia.',
            repeat_rate: 'Mucha audiencia nueva favorece un mensaje de descubrimiento; mucha recurrente favorece uno de recordación de marca.',
            new_vs_repeat_hour: 'Usa esto para decidir qué mensaje mostrar en pantallas digitales según la hora del día.',
          },
          node_types: {
            camera: 'Cámaras',
            plate: 'Placas',
            plate_clone: 'Placas (posible clonación)',
            plate_speeding: 'Placas (exceso de velocidad)',
            plate_convoy: 'Placas (viajan juntas)',
            vehicle: 'Vehículos',
          },
          chart_mode: {
            graph: 'Grafo',
            bar: 'Barras',
            pie: 'Pastel',
          },
          timeline: {
            show_all: 'Ver todo',
            up_to: 'Hasta: {date}',
          },
        },
        color_names: {
          red: 'Rojos',
          green: 'Verdes',
          blue: 'Azules',
          white: 'Blancos',
          black: 'Negros',
          yellow: 'Amarillos',
          gray: 'Grises',
          silver: 'Plateados',
          orange: 'Naranjas',
          brown: 'Cafés',
          beige: 'Beige',
          gold: 'Dorados',
        },
        dashboard: {
          title: 'Resumen general',
          total: 'Detecciones',
          plates: 'Placas distintas',
          peak_hour: 'Hora pico',
          top_color: 'Color más común',
          range_all: 'Todo',
          detections: 'Detecciones',
          by_day: 'Detecciones por día',
          by_hour: 'Detecciones por hora',
          by_color: 'Por color',
          by_type: 'Por tipo de vehículo',
          by_brand: 'Por marca',
          by_camera: 'Detecciones por cámara',
          error: 'No se pudo cargar el resumen',
        },
        graph: {
          title: 'Grafo de trayectoria',
          plate: 'Placa',
          plate_placeholder: 'Placa (vacío = la más detectada)',
          error: 'No se pudo cargar el grafo',
          lib_error: 'No se pudo cargar la librería de grafo (NVL)',
        },
      },
    },
    saveLayout: {
      title: "Guardar layout",
      messages: {
        success: "Layout guardado correctamente",
        error: "Error al guardar el layout",
      }
    },
    face_search: {
      title: 'Búsqueda de Rostros Ntechlab',
    },
    add_slot: {
      title: 'Agregar Slot',
    }
  }
}
